import { FC, useEffect, useState } from 'react';
import { t } from "../app/Translate";
import "./FormContact.css";
import { Link } from 'react-router-dom';

interface HeaderProps{
    isocode: string   
    id: string   
}
   
const FormRegister: FC<HeaderProps> = ({ isocode, id }) => {       

    const [phone, setPhone] = useState("");
    const [correo, setCorreo] = useState("");
    const [nit, setnit] = useState("");
    const [membership, setmembership] = useState("");
    const [acepto, setAcepto] = useState(false);
    const [isvisible, setIsVisible] = useState(false);

    const [toast, setToast] = useState({ show: false, message: "", type: "" });

    const showToast = (message:string, type = "error") => {
        setToast({ show: true, message, type });        
        setTimeout(() => setToast({ show: false, message: "", type: "" }), 5000);
    };

    function validarEmail(email: string) {
        const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return regex.test(email);
    }

    const handleSubmit = async (e:any) => {
        e.preventDefault();

        if (!phone || !correo || !nit || !membership) {
            showToast(t("formcontact.form-error"), "error");
            return;
        }

        if (!acepto) {
            showToast(t("formcontact.form-accept"), "error");
            return;
        }

        if (!validarEmail(correo)){
            showToast(t("formcontact.form-validemail"), "error");
            return;
        }

        let PaisDemo = t(`countries.${isocode.toLocaleLowerCase()}`) || " "
        let Planespermitidos = ["1", "2", "4", "5"];
        let NuevoId =  Planespermitidos.includes(id) ? id : "1"        
    
        try {
            const response = await fetch("https://api.helpdeskmakos.com/notify/register", {
                method: "POST",
                headers: {
                    "Content-Type": "application/json",                 
                },
                body: 
                JSON.stringify({
                    nit: nit,
                    email: correo,
                    phone: phone,
                    plan: NuevoId,
                    member: membership,
                    isocode: PaisDemo
                })
            });

            if (!response.ok) {
                showToast(t("formcontact.form-errortotal"), "error");
            }            
            showToast(t("formcontact.form-success"), "success");

            } catch (err) {
                showToast(t("formcontact.form-errortotal"), "error");
            }
        setIsVisible(true)        
    };

    return(
        <section className='formcontact' style={{backgroundColor:"#ffffff",color:"#282C40"}}>            
            <div className='row formcontact-form'  style={{textAlign:"left", marginTop:"15px"}}>
                <div className='col-md-1'></div>
                <div className='col-md-10'>
                    <div className='row'>
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label>{t("register.idfiscal")}</label>
                                <input 
                                    type="text" 
                                    required 
                                    maxLength={15} 
                                    inputMode="text" 
                                    value={nit} 
                                    onChange={(e) => setnit(e.target.value.replace(/[^A-Za-z0-9]/g, ""))} 
                                />                        
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="form-group">
                                <label>{t("register.email")}</label>
                                <input type="email" required maxLength={100} inputMode='email' value={correo} onChange={(e) => setCorreo(e.target.value)} />
                            </div>
                        </div>

                        <div className='col-md-6'>
                            <div className="form-group">
                                <label>{t("register.phone")}</label>
                                <input type="text" required maxLength={20} inputMode='text' value={phone} onChange={(e) => setPhone(e.target.value)} />
                            </div>
                        </div>
                        
                        <div className='col-md-6'>
                            <div className="form-group">
                                <label>{t("register.membership")}</label>
                                <input 
                                    type="text" 
                                    required 
                                    maxLength={15} 
                                    inputMode="text" 
                                    value={membership} 
                                    onChange={(e) => setmembership(e.target.value.replace(/[^A-Za-z0-9]/g, ""))} 
                                />
                                {membership && (
                                    <span style={{fontWeight:"500"}}>
                                        {`https://${isocode}.appmakos.com/${membership}`}
                                    </span>                    
                                )}
                            </div>                    
                        </div>

                        <div className='col-md-12'>                                        
                            <div className="form-checkbox">
                                <input type="checkbox" id="acepto" checked={acepto} onChange={(e) => setAcepto(e.target.checked)}/>
                                <Link to={t("terms.url")} className='linkterms'  target="_blank">{t("formcontact.form-checkmsg")}</Link>                        
                            </div>
                            <div style={{textAlign:"right", width:"100%"}}>
                                <button type="submit" onClick={handleSubmit} disabled={isvisible} className="animated-button">{t("register.button")}</button>
                            </div>
                            

                            {toast.show && (
                                <div className={`toast ${toast.type}`}>
                                {toast.message}
                                </div>
                            )}
                        </div>
                    </div>
                </div>
                <div className='col-md-1'></div>                                
            </div>            
        </section>
    )
}


export default FormRegister;